#import "@/v1-console/package/package.fragment.gql"

fragment PackageAccessFragment on PackageAccess {
  ApiName
  IsDeleted
  HasAccess
  Limit
  NextPackageCode
  NextPackage {
    Code
    CountryCode
    IsDeleted
    Name
    Description
    Icon
  }
  SubscriptionTypeCode
  SubscriptionType {
    Code
    Name
    Description
  }
  IsCustomAccess
}
